
            <form class="k-form k-form-horizontal" style="max-width: 700px;width: 700px;" [formGroup]="formGroup">
            

                <fieldset class="k-form-fieldset">
                    
                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="refTipoFerramenta"  [text]="customMsgService.translate('tooltype')"> </kendo-label>
                        <kendo-dropdownlist formControlName="refTipoFerramenta"
                        textField="nome"
                        valueField="id"
                        formControlName="refTipoFerramenta" 
                        [valuePrimitive]="true"
                        [defaultItem]="placeHolder"
                        [data]="listItemsTiposFerrramenta"  #refTipoFerramenta required>
                        </kendo-dropdownlist>
                        <kendo-formerror>  {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }}  {{ customMsgService.translate('tooltype') }}   {{ customMsgService.translate('isRequired') }}</kendo-formerror>

                    </kendo-formfield>

                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="marca" [text]="customMsgService.translate('brand')"> </kendo-label>
                        <kendo-textbox formControlName="marca" [clearButton]="true" #marca required> </kendo-textbox>
                        <kendo-formerror> Error: marca is required </kendo-formerror>
                    </kendo-formfield>

                    <kendo-formfield orientation="horizontal">
                        <kendo-label [for]="modelo" [text]="customMsgService.translate('model')"> </kendo-label>
                        <kendo-textbox formControlName="modelo" [clearButton]="true" #modelo required> </kendo-textbox>
                        <kendo-formerror> Error: Nome is required </kendo-formerror>
                    </kendo-formfield>

                   
                  
                    <kendo-formfield orientation="horizontal">
                        <kendo-label [for]="descontinuado" [text]="customMsgService.translate('descontinuado')"> </kendo-label>
                        <!-- <kendo-switch #descontinuado formControlName="descontinuado"> </kendo-switch> -->
                        <input type="checkbox" #descontinuado formControlName="descontinuado" kendoCheckBox />
                        <kendo-formerror> Error: This field is required </kendo-formerror>
                    </kendo-formfield>

                    <hr />
                    <div class="k-form-buttons">
                        <button kendoButton (click)="cancelChanges()">
                            {{ customMsgService.translate('cancel') }}
                        </button>
                        <button kendoButton [primary]="true" [disabled]="formGroup.invalid || formGroup.pristine" (click)="saveChanges()">
                            {{ customMsgService.translate('saveChanges') }}
                        </button>
                    </div>
                </fieldset>

    
      
            </form>

